import { Button, Tooltip } from '@tecsinapse/cortex-react'
import React from 'react'
import { GoQuestion } from 'react-icons/go'
import { useSuperAdminForm } from '../hooks/use-form'
import { FormProvider, useFormState } from 'react-hook-form'
import FormSingleSelect from '../../hook-form-connectors/form-single-select'
import { FormTextField } from '../../hook-form-connectors/form-text-field'
import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'

export const Produto = () => {
  const { form, onSubmit, handleProdutoChange, produtos } = useSuperAdminForm()
  const { handleSubmit } = form
  const { isValid, isDirty } = useFormState({ control: form.control })

  return (
    <FormProvider {...form}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={'flex flex-col gap-deca'}
      >
        <div className={'flex flex-1 flex-col items-center justify-start'}>
          <div className={'flex w-[100%] space-x-deca items-center'}>
            <FormSingleSelect
              name='produto'
              label='Produto'
              options={produtos.map(({ id, nome }) => ({
                value: id,
                label: nome
              }))}
              customOnChange={handleProdutoChange}
            />
            <FormTextField name='baseUriHomolog' label={t`URI Homolog`} />
          </div>
        </div>

        <div className={'flex flex-row items-center space-x-deca f'}>
          <Button
            type={'submit'}
            disabled={!(isValid && isDirty)}
            variants={{
              className: 'w-[calc(50%-8px)] mt-deca'
            }}
          >
            <Trans>Atualizar</Trans>
          </Button>
          <Tooltip
            text={t`Para atualizar a URL de um produto, selecione o produto desejado e insira a URL do seu ambiente sem a '/' no final.`}
          >
            <GoQuestion
              className={'text-primary-medium hover:cursor-pointer mt-deca'}
              size={24}
            />
          </Tooltip>
        </div>
      </form>
    </FormProvider>
  )
}
